import React, { Fragment } from "react";
import { Flow } from "flow-react";
import { observer } from "mobx-react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import * as actions from "store/actions";
import * as ConfigTypes from "config/ConfigTypes";
import Form from "react-bootstrap/Form";
import AppButton from "components/Button/Button";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { getMetaConfig, getDropdownData } from "helpers/ConfigHelper";
import AppDropdown from 'components/Dropdown/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./SearchBox.scss";

const SearchBox = observer(
  class SearchBox extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        data: [],
        viewMode: ConfigTypes.SEARCH_PAGE,
      };
    }

    initData = () => {
      ConfigTypes.SEARCH_PARTS.forEach(item => this.setState({ [item.name]: {} }))
      const data = getMetaConfig({
        viewMode: this.state.viewMode,
        props: this.props,
        configName: ConfigTypes.WORK
      });
      if (data && data.length) {
        this.setState({ data: data, searchSortCurrent: data[0] });
      }
    };

    searchByFields = () => {
      const { lastView } = this.props.mediaObjects;
      let workSearch = true;
      let fields = [];
      let viewMode = ConfigTypes.GRID;
      if (lastView) viewMode = lastView;
      if (workSearch) {
        ConfigTypes.SEARCH_PARTS.forEach(part => {
          for (let i in this.state[part.name]) {
            if (!i.includes('_type') && !i.includes('_current')) {
              let type = ConfigTypes.DEFAULT_SEARCH_TYPE;
              if (this.state[part.name][`${i}_type`]) type = this.state[part.name][`${i}_type`];
              fields.push({ field: i, type: type, value: this.state[part.name][i] });
            }
          }
        })
        console.log("LOGS: SearchBox searchWorks");
        this.props.searchWorks({ fields, keyword: this.state.searchText });
      }
      else this.props.searchObjects({ keyword: this.state.searchText, fields });
      this.setState({ viewMode });
      this.props.updateMediaObjects({ viewMode, workSearch, keyword: this.state.searchText, searchFields: fields });
    };

    showSearchFullTxt = () => {
      return (
        <div className="searchbox-fulltext-box">
          <h3 className="searchbox-fulltext-heading">
            {this.props.intl.formatMessage({ id: "searchbox.search" })}
          </h3>
          <input type="text" placeholder={this.props.intl.formatMessage({ id: "searchbox.search.txt" })}
            onChange={(e) => this.setState({ searchText: e.target.value })} />
          <div className="searchbox-fulltext-icon">
            <FontAwesomeIcon icon={faSearch} />
          </div>
        </div>
      )
    }

    onChangeHandler = ({ item, part }) => (e) => {
      const { value } = e.target;
      this.setState({
        [part.name]: {
          ...this.state[part.name],
          [item.field]: value,
          [`${item.field}_type`]: item[`${this.state.viewMode}searchtype`]
        }
      });
    };

    onDDClick = ({ item, part }) => (option) => {
      this.setState({
        [part.name]: {
          ...this.state[part.name],
          [item.field]: option.name,
          [`${item.field}_current`]: option,
          [`${item.field}_type`]: item[`${this.state.viewMode}searchtype`]
        }
      });

    }

    showDD = ({ part, item, i }) => {
      let groupClass = "searchbox-formcontrol";
      if (part.groupClass) groupClass = "searchbox-formgroup";
      let data = getDropdownData({ item, viewMode: this.state.viewMode });
      if (data)
        return (
          <Form.Group className={groupClass}
            key={`searchboxCatalog${i}`}
            controlId="exampleForm.ControlInput1" >
            <Form.Label>
              {this.props.intl.formatMessage({ id: item.intl })}
            </Form.Label>
            <div className="searchbox-dd-box">
              <AppDropdown
                data={data} current={this.state[part.name][`${item.field}_current`]}
                onDDClick={this.onDDClick({ item, part })} />
            </div>
          </Form.Group>
        );
      return <div></div>
    }

    showInput = ({ part, item, i }) => {
      let groupClass = "searchbox-formcontrol";
      if (part.groupClass) groupClass = "searchbox-formgroup";
      return (
        <Form.Group className={groupClass}
          key={`searchboxCatalog${i}`}
          controlId="exampleForm.ControlInput1" >
          <Form.Label>
            {this.props.intl.formatMessage({ id: item.intl })}
          </Form.Label>
          <Form.Control onChange={this.onChangeHandler({ item, part })}
            value={this.state[part.name][item.field]} type={item.type}
            placeholder={this.props.intl.formatMessage({ id: item.intl })} />
        </Form.Group>
      );
    }

    showPart = ({ part }) => {
      return this.state.data.map((item, i) => {
        if (item[`${this.state.viewMode}${part.name}`]) {
          if (item[`${this.state.viewMode}type`] === 'dropdown') {
            return this.showDD({ part, item, i });
          }
          return this.showInput({ part, item, i });
        }
      });
    };

    componentDidMount() {
      this.initData();
    }

    render() {
      return (
        <div className={`searchbox ${ConfigTypes.MODE_DARK === true && " searchbox-dark"}`} >
          <div className="col-sm-12 col-md-10 mx-auto">
            <h2 className="searchbox-heading">
              {this.props.intl.formatMessage({ id: "searchbox.heading.search" })}
            </h2>
            {this.showSearchFullTxt()}
            <div className="row searchbox-wrapper">
              {ConfigTypes.SEARCH_PARTS.map((item, i) => {
                return (
                  <div className={item.htmlClass || "col-sm-12 col-md-6 col-lg-5 col-xxl-5"}
                    key={`searchboxPart${i}`}>
                    {item.intl && (
                      <h1 className="searchbox-heading">
                        {this.props.intl.formatMessage({ id: item.intl })}
                      </h1>
                    )}
                    <Form>{this.showPart({ part: item })}</Form>
                    {item.withBtn && (<div className="searchbox-btn-wrapper">
                      <AppButton icon={faSearch} className="searchbox-btn-search"
                        btnTxt={this.props.intl.formatMessage({ id: "searchbox.button.search" })}
                        onClick={this.searchByFields} />
                    </div>)}
                  </div>)
              })}
            </div>
          </div>
        </div>
      );
    }
  }
);

const mapStateToProps = (state) => ({
  mediaObjects: state.media.mediaObjects,
  configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
  updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
  searchObjects: (data) => dispatch(actions.searchObjects(data)),
  searchWorks: (data) => dispatch(actions.searchWorks(data)),
});

export default Flow.injectFlow(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(SearchBox))
);
